<template>
	<v-layout>
		<v-flex sm12 md6 class="mb-1 pb-1">
			<p class="add-event-step-header">What type of venue is this?</p>
			<v-radio-group v-model="typeSelection" :mandatory="false" class="mt-0">
				<div v-for="type in types" class="mb-4" :key="type.value">
					<v-radio
						:value="type.value"
						class="mt-2 mb-0 add-event-radio-selection disabled-radio"
					></v-radio>
					<div class="add-event-radio-title">
						{{ type.title }}
					</div>
					<div class="add-event-radio-description">
						{{ type.description }}
					</div>
				</div>
			</v-radio-group>
		</v-flex>
		<v-flex xs12 md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<p class="add-event-tip-content">WRKPRTY events can happen anywhere, as long as the space is right for the type of experience you are hosting.</p>
					<p class="add-event-tip-content">Most commonly, hosts use homes.  But any kind of space can make an incredible work day or evening experience</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<img class="info-mobile-icon" src="/static/images/icon/light-bulb-gray.svg" />
				</v-card-title>
				<v-divider class="pt-0 mt-0">
				</v-divider>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-tip-content">WRKPRTY events can happen anywhere, as long as the space is right for the type of experience you are hosting.</p>
					<p class="add-event-tip-content">Most commonly, hosts use homes.  But any kind of space can make an incredible work day or evening experience</p>
				</v-card-text>
				<v-divider>
				</v-divider>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn icon class="info-mobile-dialog-close-button" @click="infoDialog=false"><v-icon>close</v-icon></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			types: [
				{
					title: 'Home',
					value: 'house',
					description: 'House, Apartment, Private Residence'
				},
				// { title: 'Apartment', value: 'apartment', description: 'A smaller place where you sleep' },
				// { title: 'Office', value: 'office', description: 'A professional setting where people typically work' },
				{
					title: 'Public',
					value: 'public',
					description: 'A public place such as a park'
				},
				{
					title: 'Commercial',
					value: 'commercial',
					description: 'A cafe, restaurant, coworking space, etc.'
				}
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.typeSelection !== null) {
			this.setAddLocationValidStep(from.path)
			this.removeAddLocationInvalidStep(from.path)
		} else {
			this.setAddLocationInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setAddLocationProp',
			'setAddLocationValidStep',
			'setAddLocationInvalidStep',
			'removeAddLocationInvalidStep'
		])
	},
	computed: {
		...mapGetters(['getAddLocationProp']),
		typeSelection: {
			get() {
				return this.getAddLocationProp('type')
			},
			set(val) {
				this.setAddLocationProp({
					prop: 'type',
					value: val
				})
			}
		},
		infoDialog: {
			get() {
				return this.getAddLocationProp('infoDialog')
			},
			set(val) {
				this.setAddLocationProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style scoped lang="scss">
.add-event-radio-selection {
	height: 0;
	label {
		display: none !important;
	}
}
</style>
